export default "__VITE_ASSET__UXFCZ_u8__"